import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TVideoText(props) {
  const { answers, getJson } = props;
  const categoryId = 1;
  const type = "TVideoText";

  useEffect(() => {
    if (answers.length <= 0) {
      getJson({ categoryId, type, answers: [{ selected: "" }] });
    }
  }, [answers, getJson]);

  return (
    <TextField
      disabled
      fullWidth
      type="text"
      label="texto de respuesta corta"
    />
  );
}

TVideoText.propTypes = {
  answers: PropTypes.array.isRequired,
  getJson: PropTypes.func,
};
